import { environment as base } from './environment.base';

export const environment = {
  ...base,
  stripeDashboardUrl: 'https://dashboard.stripe.com/test/'
};
